import React from 'react';
import BrandLogo from './brand-logo';
interface LogoProps {
    width?: number;
    height?: number;
}
const Logo: React.FC<LogoProps> = ({ width, height }) => {
    return <BrandLogo width={width} height={height} />;
};

export default Logo;
